import React from "react";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

import { VisitType, visitTypeLabels } from "~/services";
import { icons } from "~/ui";

const userTypeButtonVariants = tv({
  base: "flex items-center max-w-86 w-full justify-between gap-2 rounded-md border-1 border-neutral-400 px-4 py-3 text-md font-light transition-all text-indigo hover:border-violet-800",
  variants: {
    clickable: {
      true: "cursor-pointer",
    },
  },
  defaultVariants: {
    clickable: true,
  },
});

interface VisitTypeButtonProps extends VariantProps<
  typeof userTypeButtonVariants
> {
  visitType: VisitType;
  onClick?: () => void;
  disabled?: boolean;
}

export const VisitTypeButton = ({
  visitType,
  onClick,
  disabled = false,
}: VisitTypeButtonProps) => {
  const isClickable = !disabled;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={userTypeButtonVariants({
        clickable: isClickable,
      })}
    >
      <span>{visitTypeLabels[visitType]}</span>
      {isClickable && (
        <icons.outline.ChevronRightIcon className="stroke-3 h-5 w-5 text-gray-400" />
      )}
    </button>
  );
};
